
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/strategia-rozvoja-lektorov-a-timu",
      function () {
        return require("private-next-pages/strategia-rozvoja-lektorov-a-timu.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/strategia-rozvoja-lektorov-a-timu"])
      });
    }
  